import { createStore } from 'vuex';

export default createStore({
  state: {
    user: null, // Start with no cached user data
    equipment: [] // Added equipment state
  },
  mutations: {
    setUser(state, userData) {
      state.user = userData;
    },
    clearUser(state) {
      state.user = null;
    },
    setEquipment(state, equipment) {
      state.equipment = equipment;
    },
  },
  actions: {
    async login({ commit, dispatch }, credentials) {
        console.log("Vuex login action triggered with:", credentials);
	try {
        const response = await fetch('/api/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include', // Ensure cookies are sent with the request
          body: JSON.stringify(credentials),
        });
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || 'Login failed');
        }
        const result = await response.json();
        commit('setUser', result.user);
        dispatch('fetchEquipment');
        console.log("Vuex login action successful");
        return result;
      } catch (error) {
        console.error('Login error:', error);
        throw error;
      }
    },
    async logout({ commit }) {
      try {
        const response = await fetch('/api/logout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || 'Logout failed');
        }
      } catch (error) {
        console.error('Logout error:', error);
      }
      commit('clearUser');
      commit('setEquipment', []);
    },
    async fetchUserProfile({ commit, dispatch }) {
      try {
        const response = await fetch('/api/user', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include', // Include session cookie with the request
        });
        if (response.ok) {
          const userData = await response.json();
          commit('setUser', userData);
          dispatch('fetchEquipment');
        } else {
          commit('clearUser');
        }
      } catch (error) {
        console.error('Error fetching user profile:', error);
        commit('clearUser');
      }
    },
    // New action to initialize user data on app startup
    async initUser({ dispatch }) {
      await dispatch('fetchUserProfile');
    },
    async fetchEquipment({ commit, state }) {
      if (!state.user || !state.user.id) return;
      try {
        const response = await fetch(`/api/equipment/${state.user.id}`, {
          credentials: 'include',
        });
        if (response.ok) {
          const data = await response.json();
          commit('setEquipment', data.equipment);
        }
      } catch (error) {
        console.error('Error fetching equipment:', error);
      }
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.user,
    getUser: (state) => state.user,
    getEquipment: (state) => state.equipment,
  },
});
